import React, { forwardRef, useEffect, useState } from "react";
import EligibilityPanel from "../Availity/ListUi";
import { useMedplum } from "@medplum/react";
import { getPatientName, patientSearchList } from "../EligibiltyService";
import { circularPlatformLogo } from "../../../utils";
import { mapClaimResponses } from "./ClaimService";
import { useNavigate } from "react-router-dom";
import { Group, Text } from "@mantine/core";

const PriorAuth: React.FC = () => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  // Specify the types based on your data structure
  const updatedServiceTypeMap: any = [];
  const filter: any = [];
  const totalCERes = 0;
  const searchLoader = false;
  const currentPage = 1;
  const total = 0;
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState("");
  const [claimData,setClaimData]=useState<any>([])
  const [claimResponse, setClaimResponse] = useState<any>([]);
  const [patientData,setPatientData]=useState<any>([])
  const [patientList, setPatientList] = useState<[]>([]);
  const [selctedPatient, setselectedPatient] = useState<string>();
  const [ispatientfetched, setisPateintFetched] = useState<boolean>(false);
const encodeIDs = (ids: any) => ids.map((id: any) => encodeURIComponent(id));

  const medplum = useMedplum(); // Assuming you have a styles hook
  const getClaimResponse = async (singlePatientId?: string) => {
    try {
      // Construct the URL for ClaimResponse
      const patientFilter = singlePatientId
        ? `&patient=Patient%2F${singlePatientId}`
        : ""; // Use the single patient ID if provided

      const urlForClaimResponse = `use=claim&_count=20&_offset=0&_sort=-_lastUpdated&_total=accurate${patientFilter}`;

      // Fetch ClaimResponse resources
      const claimResponses = await medplum.searchResources(
        "ClaimResponse",
        urlForClaimResponse
      );

      // Set claimResponses state
      setClaimResponse(claimResponses); // Assuming setClaimResponse is a state setter function

      // Extract patient IDs from claimResponses
      const patientIds = claimResponses.map(
        (claim: any) => claim?.patient?.reference.split("/")[1]
      );

      // Include the single patient ID in the list of patient IDs if it exists
      if (singlePatientId && !patientIds.includes(singlePatientId)) {
        patientIds.push(singlePatientId);
      }


      // Encode the patient IDs for query
      const urlForPatient = `_count=20&_id=${encodeIDs(
        patientIds
      )}&_sort=-_lastUpdated&_total=accurate`;

      // Fetch Patient resources using the encoded patient IDs
      const patientResponse = await medplum.searchResources(
        "Patient",
        urlForPatient
      );

      // Build patient details map
      const patientDetails = patientResponse.reduce(
        (acc: any, patient: any) => {
          const patientId = patient?.id;
          const patientName = getPatientName(patient?.name);

          if (patientId && patientName) {
            acc[patientId] = patientName;
          }
          return acc;
        },
        {}
      );

      // Set patient data
      setPatientData(patientDetails); // Assuming setPatientData is a state setter function

      // Map claimResponses with patient details
      const listClaimData = mapClaimResponses(patientDetails, claimResponses);
      setClaimData(listClaimData); // Assuming setClaimData is a state setter function
    } catch (error) {
      console.error("Error fetching ClaimResponse or Patient data:", error);
    }finally{setIsCreating(false)}
  };

  useEffect(() => {
    setIsCreating(true)
    getClaimResponse();
  }, []);
    useEffect(() => {
      getClaimResponse(selctedPatient);
    }, [selctedPatient]);

  useEffect(() => {
    patientSearch(searchQuery);
  }, [searchQuery]);


  
  const patientSearch = async (val: any) => {
    //    setisPateintFetched(true);
    const pateintResponse = await patientSearchList(val, medplum);
    if (pateintResponse?.length == 0) {
      setisPateintFetched(false);
    }

    const patientData = pateintResponse.map((patient: any) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding: any) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item: any) => item.system && item.system.includes("athena")
      );
      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id: any) =>
            id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img
              src={circularPlatformLogo["epic"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="EPIC"
            />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img
              src={circularPlatformLogo["cerner"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Cerner"
            />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img
              src={circularPlatformLogo["athenahealth"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Athena"
            />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={circularPlatformLogo["others"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Others"
            />
          );
      }
      return {
        label: getPatientName(patient.name),
        value: patient.id,
        ehr: ehrtype,
        icon: EHRIcon,
      };
    });
    setisPateintFetched(false);
    setPatientList(patientData);
  };

  const handleFilterChange = (value: string[]) => {};

  const handleApply = () => {};
  const handleChange = (value: any) => {
    setselectedPatient(value);
  };
   interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
     label: string;
     value: any;
     ehr: string;
     icon: any;
   }

   const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
     ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
       <div ref={ref} {...others}>
         <Group
           noWrap
           sx={{
             justifyContent: "space-between",
             height: "30px",
             width: "100%",
           }}
         >
           <div>
             <Text>{label}</Text>
           </div>
           <div>{icon}</div>
         </Group>
       </div>
     )
   );
  //   const handleChange = (value: string | null) => {
  //     setSearchValue(value);
  //   };

  const onSearchChange = (value: string) => {
    setSearchQuery(value);
  };

  const handlePageChange = (page: number) => {};

  return (
    <EligibilityPanel
    itemComponent={SelectItem}
      nameOfComponent={"Claims"}
      isFilterModalOpen={false}
      setIsFilterModalOpen={setIsFilterModalOpen}
      isCreating={isCreating}
      updatedServiceTypeMap={updatedServiceTypeMap}
      handleFilterChange={handleFilterChange}
      filter={filter}
      handleApply={handleApply}
      totalCERes={totalCERes}
      totalRequest={claimData?.length}
      serviceType={"claims"}
      navigate={navigate} // Your navigate logic here
      patientList={patientList}
      handleChange={handleChange}
      onSearchChange={onSearchChange}
      searchQuery={searchQuery}
      isPatientFetched={ispatientfetched} // Your logic here
      coverageData={claimData}
      mappedCResponseList={claimData}
      handleClickDetails={(e:any) => {navigate(`/admin/insurance/claims/details?id=${e}`);}} // Your details click logic here
      searchLoader={searchLoader}
      currentPage={currentPage}
      total={total}
      rejected={0}
      accepted={0}
      label={{
        providerName: "Payer",
        practiceType: "Service Type",
        requestId: "Amount",
        backOffice: "Created On",
      }}
      handlePageChange={handlePageChange}
    />
  );
};

export default PriorAuth;
